<template>
    <div col-md-12 mx-auto>
        <div class="card-header">
            <page-title :title="$t('finance.pageTitle')"></page-title>
        </div>

        <div>
            <tabs :options="{ useUrlFragment: false }"
                  cache-lifetime="10"
                  @changed="tabChanged">
                <tab id="tarif-groups-tab" :name="$t('finance.tabcontrol.groups')">
                    <tariff-groups-grid v-if="groupTabIsActive"></tariff-groups-grid>
                </tab>
                <tab id="tarif-items-tab" :name="$t('finance.tabcontrol.tariffItems')">
                    <tariff-items-grid v-if="itemsTabIsActive"></tariff-items-grid>
                </tab>
                <tab id="tarif-entities-tab" :name="$t('finance.tabcontrol.tariffEntity')">
                    <tariff-entities-grid v-if="entitiesTabIsActive"></tariff-entities-grid>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PageTitle from '../../components/common/PageTitle';
    import TariffGroupsGrid from '../../components/finance/TariffGroupsGrid';
    import TariffItemsGrid from '../../components/finance/TariffItemsGrid';
    import TariffEntitiesGrid from '../../components/finance/TariffEntitiesGrid';

    import CustomTabs from '../../components/tab/CustomTabs'
    Vue.use(CustomTabs);

    export default {
        components: {
            PageTitle,
            'tariff-groups-grid': TariffGroupsGrid,
            'tariff-items-grid': TariffItemsGrid,
            'tariff-entities-grid': TariffEntitiesGrid
        },
        data: function () {
            return {
                groupTabIsActive: false,
                itemsTabIsActive: false,
                entitiesTabIsActive: false,
            }
        },
        methods: {
            tabChanged(selectedTab) {
                console.log('Tab changed to:' + selectedTab.tab.id);
                switch (selectedTab.tab.id) {
                    case 'tarif-groups-tab':
                        this.groupTabIsActive = true;
                        this.itemsTabIsActive = false;
                        this.entitiesTabIsActive = false;
                        break;
                    case 'tarif-items-tab':
                        this.groupTabIsActive = false;
                        this.itemsTabIsActive = true;
                        this.entitiesTabIsActive = false;
                        break;
                    case 'tarif-entities-tab':
                        this.groupTabIsActive = false;
                        this.itemsTabIsActive = false;
                        this.entitiesTabIsActive = true;
                        break;
                    default:
                        this.groupTabIsActive = false;
                        this.itemsTabIsActive = false;
                        this.entitiesTabIsActive = false;
                }
            },
        },
        computed: {

        }
    }
</script>

